import React from 'react';
import { NavigationSkeleton as TopNavigationSkeleton } from '@atlaskit/atlassian-navigation/skeleton';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { useTheme } from '../../controllers/theme/main.tsx';

export const JiraAtlassianNavigationSkeleton = () => {
	const theme = useTheme();
	return (
		<UFOLoadHold name="top-navigation">
			<TopNavigationSkeleton theme={theme} />
		</UFOLoadHold>
	);
};
